module.exports = __webpack_public_path__ + "img/header-weddingRingsMorningGlow@2x.963cb09.webp";